import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import UISideNav from 'UIComponents/nav/UISideNav';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { hasAdsGoalsReadAccess // @ts-expect-error cannot find declaration file
} from 'AdsUI/selectors/AuthSelectors';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
const GOALS_GENERAL_UPGRADE_KEY = 'goals-general-upgrade-modal';

const AnalyzeSidebar = ({
  location,
  history,
  canReadAdsGoals
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal(GOALS_GENERAL_UPGRADE_KEY);
  const navigateGoals = useCallback(() => {
    if (!canReadAdsGoals) {
      openUpgradeModal();
      return;
    }

    history.push('/goals');
  }, [history, canReadAdsGoals, openUpgradeModal]);
  return /*#__PURE__*/_jsxs(UISideNav, {
    value: location.pathname,
    children: [/*#__PURE__*/_jsx(UISideNavItem, {
      value: "/dashboard",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "analyze"
      }),
      onClick: () => history.push('/dashboard')
    }), /*#__PURE__*/_jsx(UISideNavItem, {
      value: "/goals",
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "goals"
        }), !canReadAdsGoals && /*#__PURE__*/_jsx(UILockBadge, {
          "data-test-id": "goals-navigation-lock"
        })]
      }),
      onClick: navigateGoals
    })]
  });
};

export default connect(state => ({
  canReadAdsGoals: hasAdsGoalsReadAccess(state)
}))(withRouter(AnalyzeSidebar));